export default function getAgeFromDOB(dateString: string) {
  if (!dateString) {
    return;
  }

  const diffMiliseconds = Date.now() - new Date(dateString).getTime();
  const ageDate = new Date(diffMiliseconds); // miliseconds from epoch

  return Math.abs(ageDate.getUTCFullYear() - 1970).toString();
}
